import { useEffect } from 'react'

import { usePlayerStore } from '../services/store'
import { useConfigValueByCurrentDevice } from './useConfigValueByCurrentDevice'
import { config } from '../components/Init/Init'
import { extractLoyaltyTierParts } from '../services/utils'
import { useSetPlayerLoyaltyData } from '../services/store/playerStore/playerActions'

export default function useLoyaltyUserData(delayRequest) {
  const enableFirebaseLoyaltyUserData = useConfigValueByCurrentDevice(config.enableFirebaseLoyaltyUserData)
  const playerStore = usePlayerStore()
  const playerUserId = playerStore.use.userId()

  const { setPlayerLoyaltyData } = useSetPlayerLoyaltyData()

  useEffect(() => {
    if (!enableFirebaseLoyaltyUserData || !window.rmgBase || delayRequest) {
      return
    }
    const db = window.rmgBase.database(config.userDataFirebaseConfig.databaseURL)
    db.ref(`users/${playerUserId}/sweeps_user_profile`).once('value', snapshot => {
      let snapshotVal = snapshot.val()
      if (snapshotVal) {
        setPlayerLoyaltyData({
          currentTier: snapshotVal.loyalty_tier ? extractLoyaltyTierParts(snapshotVal.loyalty_tier) : {},
          progress: snapshotVal.loyalty_tier_progress * 100
        })
      } else {
        setPlayerLoyaltyData({
          currentTier: extractLoyaltyTierParts('1'),
          progress: 0
        })
      }
    })
  }, [delayRequest])
}
